// ======================================================================
// File Name       : ContentSingleQuestionAnswerList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import FileUpload from '../../components/FileUpload';
import { ANSWER_FORMULA } from '../../constants/ContentConstant';
import { htmlEntities } from '../../utils/index';

class ContentSingleQuestionAnswerList extends React.Component {
  render() {
    const { answerInfo, isFormulaType, isShowDetail } = this.props;
    let { answerFormula } = this.props;
    answerFormula = answerFormula ? answerFormula.toString() : '0';
    const isNotMaxColumn =
      answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER ||
      answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER ||
      answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT ||
      answerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER;
    const answerInfoView = answerInfo
      ? answerInfo.map((answer, index) => {
        const subConvertedAnswerList = [];
        if (answer.subAnswer && answer.subAnswer.length) {
          answer.subAnswer.forEach((subAnswerElement) => {
            const convertSubAnswer = htmlEntities(subAnswerElement, false);
            subConvertedAnswerList.push(convertSubAnswer);
          });
        }
        return (
          <tr key={index}>
            <td>
              {answer.answerChoice}
              {answer.correctAnswer ? htmlEntities(answer.correctAnswer, false) : ''}
              {answer.subAnswer.length > 0 && '/'}
              {subConvertedAnswerList.length ? subConvertedAnswerList.join('/') : answer.subAnswer.join('/')}
            </td>
            {!isNotMaxColumn &&
            <td className="text-center">
              {answerFormula === ANSWER_FORMULA.SELECTIVE_SORT_ANSWER ||
                  answerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER
                    ? answer.correctAnswerNumber
                    : <Form.Check
                type='checkbox'
                checked={answer.isCorrectAnswer == true || answer.isCorrectAnswer == 1}
                disabled />}
            </td>}
            {!isShowDetail && <td className="text-center">
              <Button
                variant="primary"
                className="btn-96"
                onClick={this.props.showAddAnswerDlg.bind(this, index)}
              >
                  編集
              </Button>
            </td>}
            {!isShowDetail && <td className="text-center">
              <i
                onClick={this.props.removeAnswer.bind(this, index)}
                className="bi bi-trash cursor_pointer"
              />
            </td>}
          </tr>
        );
      })
      : null;
    return (
      <div className="col-sm-12">
        {this.props.answerInfo &&
          <Form.Group className="form-info">
            {!isShowDetail && <Col sm={4} />}
            <Col sm={!isShowDetail ? 7 : 12} className={!isShowDetail ? '' : 'padding-left-right-clear'}>
              <Table striped hover>
                <thead>
                  <tr>
                    {isFormulaType ? <th>選択肢</th> : <th>正解記述内容</th>}
                    {!isNotMaxColumn && <th width="60">正解</th>}
                    {!isShowDetail && <th width="110">操作</th>}
                    {!isShowDetail && <th width="60">削除</th>}
                  </tr>
                </thead>
                <tbody>
                  {answerInfoView}
                </tbody>
              </Table>
            </Col>
          </Form.Group>}
      </div>
    );
  }
}
export default ContentSingleQuestionAnswerList;
